__webpack_require__.p = "/react-homework17/";